"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContextValue = void 0;
const helpers_1 = require("../../helpers");
class ModalContextValue {
    constructor() {
        this.stack = [];
        this.listeners = [];
        this.portalDomNode = null;
        this.getPortalDomNode = () => {
            if (!this.portalDomNode) {
                this.portalDomNode = (0, helpers_1.createPortalDomNode)();
            }
            return this.portalDomNode;
        };
        this.addToStack = (el) => {
            this.stack.push(el);
        };
        this.removeFromStack = (el) => {
            this.stack = this.stack.filter((i) => i !== el);
        };
        this.getLastFromStack = () => {
            if (this.stack.length > 0) {
                return this.stack[this.stack.length - 1];
            }
            return null;
        };
        this.getPrevFromStack = () => {
            if (this.stack.length > 1) {
                return this.stack[this.stack.length - 2];
            }
            return null;
        };
        this.addListener = (cb) => {
            this.listeners.push(cb);
            return () => {
                this.listeners = this.listeners.filter((c) => c !== cb);
            };
        };
        this.notify = () => {
            this.listeners.forEach((cb) => cb());
        };
    }
}
exports.ModalContextValue = ModalContextValue;
//# sourceMappingURL=ModalContextValue.js.map